import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import useApiFunction from "../../api/useApiFunction";
import valueContext from "../../customHook/useContext";

function Login() {
  const navigate = useNavigate();
  const { authFunc } = useApiFunction();
  const { crypt, splitToken } = useContext(valueContext);
  const [isLoading, setIsLoading] = useState(false);
  const [loginInput, setLoginInput] = useState({
    username: "",
    password: "",
  });
  const handleChange = (e) => {
    setLoginInput({
      ...loginInput,
      [e.target.name]: e.target.value,
    });
  };
  function togglePasswordVisibility(str) {
    var passwordInput = document.getElementById(`${str}`);

    if (passwordInput.type === "password") {
      passwordInput.type = "text";
    } else {
      passwordInput.type = "password";
    }
  }
  async function submitLogin(e) {
    e.preventDefault();
    setIsLoading(true);
    if (!loginInput.username || !loginInput.password) {
      toast.warning("Please fill all the details", {
        autoClose: 2000,
      });
      setIsLoading(false);
    } else {
      let body = JSON.stringify({
        userName: loginInput.username,
        password: loginInput.password,
      });
      const res = await authFunc(`member/signIn`, body, "POST");
      if (res.status) {
        setIsLoading(false);
        if (res?.msg) {
          const token = splitToken(res.msg);
          const encrypted_textA = crypt("salt", token.textA);
          const encrypted_textB = crypt("salt", token.textB);
          const encrypted_textC = crypt("salt", token.textC);
          window.localStorage.setItem("A_", encrypted_textA);
          window.localStorage.setItem("B_", encrypted_textB);
          window.localStorage.setItem("C_", encrypted_textC);

          navigate("/dashboard", { state: { msg: "Welcome To Dashboard" } });
        }
      } else if (res.error) {
        setIsLoading(false);
        toast.warning(res.error, { autoClose: 2000 });
      } else {
        setIsLoading(false);
        toast.warning(res.msg, { autoClose: 2000 });
      }
    }
  }
  function getToken() {
    const A = window.localStorage.getItem("A_");
    const B = window.localStorage.getItem("B_");
    const C = window.localStorage.getItem("C_");
    if (A && B && C) {
      navigate("/dashboard");
    }
  }

  useEffect(() => {
    getToken();
  }, []);
  return (
    <>
      <main className="main-content mt-0 " style={{ marginLeft: "0" }}>
        <div className="mt-5 ">
          <div className="account-pages">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-md-8 col-lg-6 col-xl-5">
                  <div className="card overflow-hidden">
                    <div className="bg-primary bg-soft user-profile">
                      <div className="row">
                        <div className="col-12">
                          <div className="p-4">
                            <h5
                              className=""
                              style={{ fontFamily: "Poppins, sans-serif" }}
                            >
                              Welcome Back !
                            </h5>
                            <p>
                              Sign in to continue to
                              <span style={{ color: "#00ad89" }}>
                                Tallwin Member{" "}
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card-body pt-0">
                      <div className="auth-logo">
                        <a href="index.html" className="auth-logo-light">
                          <div className="avatar-md profile-user-wid mb-4">
                            <span className="avatar-title rounded-circle bg-light">
                              <img
                                src="./assets/undraw_Unlock_re_a558.png"
                                alt=""
                                className="rounded-circle"
                              />
                            </span>
                          </div>
                        </a>
                      </div>
                      <div className="p-2 mt-3">
                        <form
                          className="form-horizontal"
                          action="index.html"
                          onSubmit={submitLogin}
                        >
                          <div className="mb-3">
                            <label
                              for="username"
                              className="form-label sub-heading"
                            >
                              Username
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="username"
                              placeholder="User ID"
                              value={loginInput.username}
                              onChange={(e) => handleChange(e)}
                              required
                            />
                          </div>
                          <div className="mb-3">
                            <label className="form-label sub-heading">
                              Password
                            </label>
                            <div className="input-group auth-pass-inputgroup">
                              <input
                                className="form-control"
                                type="password"
                                name="password"
                                id="passwordInput"
                                placeholder="Password"
                                value={loginInput.password}
                                onChange={(e) => handleChange(e)}
                                required
                              />
                              <span
                                className="btn btn-light"
                                onClick={() =>
                                  togglePasswordVisibility("passwordInput")
                                }
                              >
                                <i className="mdi mdi-eye-outline"></i>
                              </span>
                            </div>
                          </div>

                          <div className="mt-3 d-grid">
                            <button className="block-menu" type="submit">
                              {isLoading && (
                                <i
                                  className="bx bx-loader-circle rotating"
                                  style={{ marginRight: "5px" }}
                                />
                              )}
                              Log In
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <ToastContainer />
    </>
  );
}

export default Login;
